import { normalizeCurrencyCode } from "./currencyConfig";

const hasValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

export const getMatterCustomFieldValue = (customFieldsData, fieldName) => {
  if (!Array.isArray(customFieldsData) || !fieldName) return "";

  for (const section of customFieldsData) {
    const sectionName = Object.keys(section || {})[0];
    const fields = sectionName ? section?.[sectionName] : [];

    if (!Array.isArray(fields)) continue;

    const matchedField = fields.find((field) => field?.name === fieldName);
    if (matchedField && hasValue(matchedField?.value)) {
      return matchedField.value;
    }
  }

  return "";
};

export const resolveMatterCurrency = (matter, fallbackCurrency = "USD") => {
  const resolvedCurrency =
    matter?.currency ||
    getMatterCustomFieldValue(matter?.custom_fields_data, "currency") ||
    fallbackCurrency;

  return normalizeCurrencyCode(resolvedCurrency) || normalizeCurrencyCode(fallbackCurrency);
};

const resolveMatterBillableMethod = (matter) => {
  const method =
    matter?.billable_method ||
    getMatterCustomFieldValue(matter?.custom_fields_data, "billable_method");

  return typeof method === "string" ? method.trim().toLowerCase() : "";
};

export const resolveMatterHourlyRate = (matter) => {
  if (!matter || typeof matter !== "object") return "";

  const billableMethod = resolveMatterBillableMethod(matter);

  if (billableMethod === "hourly" && hasValue(matter?.billable_value)) {
    return String(matter.billable_value);
  }

  if (hasValue(matter?.hourly_rate)) {
    return String(matter.hourly_rate);
  }

  const customHourlyRate = getMatterCustomFieldValue(
    matter?.custom_fields_data,
    "hourly_rate",
  );

  if (hasValue(customHourlyRate)) {
    return String(customHourlyRate);
  }

  if (billableMethod === "hourly") {
    const customBillableValue = getMatterCustomFieldValue(
      matter?.custom_fields_data,
      "billable_value",
    );

    if (hasValue(customBillableValue)) {
      return String(customBillableValue);
    }
  }

  return "";
};
